import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  BusinessPersonWithTrainingSkeleton,
  TrainingRequirementSkeleton,
  PagedWarningRuleAudit,
  PagedTrainingRequirementAudit,
  PagedBusinessPersonTrainingRequirementAudit,
  TrainingGroupSkeleton,
  PagedTrainingGroupAudit,
  PagedTrainingGroupTrainingRequirementAudit
} from './+models/training-requirement-audit.model';

@Injectable()
export class TrainingRequirementAuditService {
  constructor(private readonly http: HttpClient) {}

  getTrainingRequirementAudits(
    trainingRequirementId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CrewCurrencyAudit/TrainingRequirement/${trainingRequirementId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedTrainingRequirementAudit>(url);
  }

  getTrainingGroupAudits(
    trainingGroupId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CrewCurrencyAudit/TrainingGroup/${trainingGroupId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedTrainingGroupAudit>(url);
  }

  getTrainingGroupTrainingRequirementAudits(
    trainingGroupTrainingRequirementId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CrewCurrencyAudit/TrainingGroupTrainingRequirement/${trainingGroupTrainingRequirementId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedTrainingGroupTrainingRequirementAudit>(url);
  }

  getWarningRuleAudits(
    warningRuleId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CrewCurrencyAudit/WarningRule/${warningRuleId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedWarningRuleAudit>(url);
  }

  getBusinessPersonTrainingRequirementAudits(
    businessPersonId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CrewCurrencyAudit/BusinessPersonTrainingRequirement/${businessPersonId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedBusinessPersonTrainingRequirementAudit>(url);
  }

  getTrainingRequirementSkeletons() {
    return this.http.get<TrainingRequirementSkeleton[]>(
      '/sdapi/profile/CrewCurrencyAudit/TrainingRequirementSkeletons'
    );
  }

  getBusinessPersonTrainingRequirementSkeletons() {
    return this.http.get<BusinessPersonWithTrainingSkeleton[]>(
      '/sdapi/profile/CrewCurrencyAudit/BusinessPersonWithTrainingSkeletons'
    );
  }

  getTrainingGroupSkeletons() {
    return this.http.get<TrainingGroupSkeleton[]>(
      '/sdapi/profile/CrewCurrencyAudit/TrainingGroupSkeletons'
    );
  }
}
